import api from '../services/api'

import { RESET } from '../redux/game'
// Actions
const FETCHING_BUSINESSES_START = 'ascension/businesses/fetching'
const FETCHING_BUSINESSES_SUCCESS = 'ascension/businesses/success'
const FETCHING_BUSINESSES_ERROR = 'ascension/businesses/error'
const BUSINESSES_CHANGE_PAGE = 'ascension/businesses/changepage'
const BUSINESSES_SELECT_BUSINESS = 'ascension/businesses/selectbusiness'

const UPDATE_DECISIONS_SUCCESS = 'ascension/decisions/success'

// Reducer
const initialState = {
  currentPage: 0,
  isLoading: false,
  isLoaded: false,
  error: null,
  selectedBusiness: null,
  businesses: []
}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCHING_BUSINESSES_START: {
      return {
        ...state,
        isLoading: true,
        businesses: [],
        selectedBusiness: null,
        error: null
      }
    }
    case FETCHING_BUSINESSES_SUCCESS: {
      let selectedBusiness = state.selectedBusiness
      if (!selectedBusiness) {
        selectedBusiness = action.data[0].type
      }
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        selectedBusiness,
        businesses: [...action.data]
      }
    }
    case UPDATE_DECISIONS_SUCCESS: {
      return {
        ...state,
        businesses: state.businesses.map(b => {
          if (b.id === action.data.businessId) {
            return {
              ...b,
              price1Now: action.data.decisions[0].price1Now,
              price2Now: action.data.decisions[1].price2Now,
              version: new Date().toISOString()
            }
          }
          return b
        })
      }
    }
    case FETCHING_BUSINESSES_ERROR: {
      return {
        ...state,
        isLoaded: false,
        isLoading: false,
        selectedBusiness: null,
        error: action.data
      }
    }
    case BUSINESSES_CHANGE_PAGE: {
      return {
        ...state,
        currentPage: action.data
      }
    }
    case BUSINESSES_SELECT_BUSINESS: {
      return {
        ...state,
        selectedBusiness: action.data
      }
    }
    case RESET: {
      return initialState
    }
    default: return state
  }
}

export default reducer

export function fetchingBusinessesStart () {
  return {
    type: FETCHING_BUSINESSES_START
  }
}

export function fetchingBusinessesSuccess (businesses) {
  return {
    type: FETCHING_BUSINESSES_SUCCESS,
    data: businesses
  }
}

export function updateDecisionsSuccess (decisions, businessId) {
  return {
    type: UPDATE_DECISIONS_SUCCESS,
    data: { decisions, businessId }
  }
}

export function fetchingBusinessesError (error) {
  return {
    type: FETCHING_BUSINESSES_ERROR,
    data: error
  }
}

export function updatePage (page) {
  return {
    type: BUSINESSES_CHANGE_PAGE,
    data: page
  }
}

// Action Creators
export function fetchBusinesses (team, round) {
  return async (dispatch) => {
    dispatch(fetchingBusinessesStart())

    try {
      const response = await api.getBusinesses(team, round)
      dispatch(fetchingBusinessesSuccess(response.businesses))
    } catch (e) {
      dispatch(fetchingBusinessesError(e))
    }
  }
}

export function fetchBusinessesBackground (team, round) {
  return async (dispatch) => {
    try {
      const response = await api.getBusinesses(team, round)
      dispatch(fetchingBusinessesSuccess(response.businesses))
    } catch (e) {

    }
  }
}

export function updateDecisions ({ team, round, decisions, deviceId }) {
  return async (dispatch) => {
    try {
      await api.updateDecisions(team, round, decisions, deviceId)
    } catch (e) {
    }
  }
}

export function updateDecisionsAndState ({ team, round, decisions, deviceId, businessId }) {
  return async (dispatch) => {
    try {
      await api.updateDecisions(team, round, decisions, deviceId)
      dispatch(updateDecisionsSuccess(decisions, businessId))
    } catch (e) {
    }
  }
}

export function updateSelectedBusiness (selectedBusiness) {
  return {
    type: BUSINESSES_SELECT_BUSINESS,
    data: selectedBusiness
  }
}
